import { createSelector } from 'reselect';
import { ModuleType } from '../../types/modules';
import {
  ProfileSkin,
  premiumSkins,
  officialSkin,
  customSkin,
} from '../../types/profileSkins';
import { getModuleDataByModuleType } from './modules';

const getState = state => state.profileSkins;

export const getActiveSkin = createSelector([getState], state => {
  return state.activeSkin;
});

export const getCustomSkin = createSelector([getState], state => {
  return state.customSkin || customSkin;
});

export const isSkinSelectorShown = state => getState(state).skinSelectorShown;

export const isSkinSaving = state => getState(state).isSkinSaving;

export const getProfileSkin = (state): ProfileSkin | undefined => {
  // active skin comes first when the selector is open
  const activeSkin = getActiveSkin(state);
  if (activeSkin && isSkinSelectorShown(state)) {
    return activeSkin;
  }

  // get the skin from the module config
  const moduleData = getModuleDataByModuleType(
    state,
    ModuleType.COVER_DEVIATION
  );
  if (!moduleData) {
    return undefined;
  }
  const skinId = moduleData?.profileSkin?.templateName;

  if (skinId) {
    if (skinId === 'official') {
      return officialSkin;
    }
    if (skinId === 'custom') {
      return getCustomSkin(state);
    }
    const skin = premiumSkins.find(
      s => s.skinId === moduleData.profileSkin.templateName
    );
    if (skin) {
      return skin;
    }
  }
  return undefined;
};
